import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, GitBranch } from 'lucide-react';
import AvatarCognitionGraph from '../components/AvatarCognitionGraph';

export default function AvatarCognitionGraphPage() {
  const { avatarId } = useParams<{ avatarId: string }>();
  const navigate = useNavigate();

  if (!avatarId) return null;

  return (
    <div className="flex flex-col h-screen font-display">
      <header className="flex items-center gap-4 px-6 py-4 border-b border-slate-200 bg-white flex-shrink-0">
        <button onClick={() => navigate(-1)} className="text-slate-400 hover:text-slate-600" aria-label="Back">
          <ArrowLeft size={20} />
        </button>
        <div className="flex items-center gap-2">
          <GitBranch size={20} className="text-primary" />
          <h1 className="text-lg font-bold text-navy">Reasoning Graph</h1>
        </div>
      </header>
      <div className="flex-1 min-h-0">
        <AvatarCognitionGraph avatarId={avatarId} />
      </div>
    </div>
  );
}
